import { AuthService } from 'src/app/Services/auth.service';
import { AuthUser, AuthConfig } from './../../Services/auth.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResponseObject } from '../../Services/auth.service';
import { ConnectedNote, ConnectedNotesService } from '../../Services/connected-notes.service';
import { ConnectedGallery, ConnectedGallerySettingRequest } from '../../Services/connections.service';
import { NotificationsService } from '../../Services/shared/notifications.service';
import { NotificationTypes } from '../../app.enums';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'notes-dialog',
    templateUrl: './notes-dialog.component.html',
    standalone: false
})
export class NotesDialogComponent implements OnInit {
  @Input() connectGallery?: ConnectedGallery;
  @Input() notesDialogVisible: boolean = false;
  @Output() onCloseDialog = new EventEmitter<boolean>();
  public selectedgallery: string = '';
public displayEmojiDialog :boolean =false
  public newNoteText: string | null = null;
  public artistId!: string;
  public notes: ConnectedNote[] = [];
  public selectedGallerySettings?: ConnectedGallerySettingRequest;
  public settingDialogVisible: boolean = false;
  public authUser: AuthUser | null = null;
  public isArtist: boolean = false;
  public isGallery: boolean = false;
  public isAuthenticated: boolean = false;
  public authConfig!: AuthConfig;

  constructor(
    private ngxSpinnerService: NgxSpinnerService,
    private notificationService: NotificationsService,
    private connectedNotesService: ConnectedNotesService,
    private authService: AuthService,
    private transloco: TranslocoService,
  ) { }

  ngOnInit(): void {
    if (this.connectGallery) {
      this.getConnectedNotes(this.connectGallery.Id);
    }
  }

  private getConnectedNotes(galleryId: string) {
    this.ngxSpinnerService.show();
    this.connectedNotesService.getConnectedNotes(this.artistId, galleryId).subscribe((response) => {
      this.ngxSpinnerService.hide();
      if(response){
        if(this.isArtist){
          console.log("artistid",this.artistId)
          this.notes = response.filter(notes=>notes.CommentsBy == this.artistId)
          console.log("for artist",this.notes)
        }
      }
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  public openNotesDialog(rowData: ConnectedGallery) {
    this.newNoteText = null;
    this.connectGallery = rowData;
    this.notesDialogVisible = true;
  }

  public saveNotes() {
    if (!this.newNoteText || !this.connectGallery) return;
    this.ngxSpinnerService.show();
    this.connectedNotesService.saveConnectedNotes(this.artistId, this.connectGallery.Id, this.newNoteText).subscribe((response: ResponseObject) => {
      this.ngxSpinnerService.hide();
      if (response.Success && this.connectGallery) {
        this.newNoteText = null;
        // Refresh the connected gallery notes on the dialog
        this.getConnectedNotes(this.connectGallery.Id);
        this.notificationService.showNotification(this.transloco.translate('notesDialog.successTitle'), this.transloco.translate('notesDialog.changesSaved'), NotificationTypes.Success);
      } else { this.notificationService.showNotification(this.transloco.translate('notesDialog.errorTitle'), response.ResponseMessage, NotificationTypes.Error); }
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  public openEmojiDialog() {
    this.displayEmojiDialog = !this.displayEmojiDialog;
  }

  public addEmoji(emoji: string) {
    console.log('Selected emoji:', emoji);
    // Append the selected emoji to the newNoteText
    this.newNoteText = (this.newNoteText || '') + emoji;
    this.displayEmojiDialog = false;
  }

  public closeEmojiDialog($event: any) {
    this.displayEmojiDialog = false;
  }

  public closeNotesDialog() {
    this.notesDialogVisible = false;
    this.onCloseDialog.emit(this.notesDialogVisible);
  }

}
